import React from 'react';
import {
  Spinner as HeroSpinner,
  SpinnerProps as HeroSpinnerProps,
} from '@heroui/react';

export interface SpinnerProps {
  size?: HeroSpinnerProps['size'];
  color?: HeroSpinnerProps['color'];
  label?: string;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'primary',
  label,
  className = '',
}) => {
  return <HeroSpinner size={size} color={color} label={label} />;
};

export default Spinner;
